import React from "react";
import { useAuth } from "../../AuthContext";
import { useLanguage } from "../../i18n";

function monthLabel(m: string) {
  const [y, mo] = m.split("-");
  return new Date(Number(y), Number(mo) - 1, 1).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
}

// Opens WhatsApp with a ready-to-send rent reminder for this tenant. It's a
// wa.me link, so the owner sends it from their own WhatsApp (no WhatsApp
// Business API involved). Renders nothing if the tenant has no phone number.
export function WhatsAppRemind({
  phone,
  tenantName,
  amount,
  month,
  spaceBelow = 0,
}: {
  phone: string | null | undefined;
  tenantName: string;
  amount: number;
  month: string;
  spaceBelow?: number;
}) {
  const { t } = useLanguage();
  const { user } = useAuth();
  const digits = (phone ?? "").replace(/\D/g, "").slice(-10);
  if (digits.length !== 10) return null;

  const base = t("ownerLedgers.waRemindMessage", {
    tenant: tenantName,
    amount: "₹" + Number(amount).toLocaleString("en-IN"),
    month: monthLabel(month),
    owner: user?.name ?? "",
  });
  const message = user?.upiId ? `${base} ${t("ownerLedgers.waRemindUpi", { upi: user.upiId })}` : base;

  return (
    <a
      className="btn-outline btn-sm"
      style={{ display: "block", textAlign: "center", marginTop: 8, marginBottom: spaceBelow, textDecoration: "none" }}
      href={`https://wa.me/91${digits}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
    >
      {t("ownerLedgers.waRemindBtn")}
    </a>
  );
}
